import { TableCell, TableRow } from '@fluentui/react-components';
import { DateLabel, SmartTableCell } from '@shared/components';
import { TAccessLog } from '../../types/accessLogs.types';
import AvatarGroup from '../AvatarGroup';
import { ITableColumnSizingState, TTableRow } from '@shared/types';

type TProps = TTableRow<TAccessLog> & {
  columnSizing: ITableColumnSizingState;
};

const AccessLogsTableRow = ({ id, item, actionButton, columnSizing }: TProps) => {
  return (
    <TableRow key={id}>
      <SmartTableCell
        cellProps={{ ...(columnSizing.getTableCellProps('description') ?? {}) }}
        variant={{ kind: 'html', html: item.description }}
        after={actionButton}
      />
      <TableCell {...columnSizing.getTableCellProps('date')}>
        <DateLabel withTime short>
          {item.date}
        </DateLabel>
      </TableCell>
      <TableCell {...columnSizing.getTableCellProps('initiator')}>
        <AvatarGroup ids={[item.initiator]} />
      </TableCell>
    </TableRow>
  );
};

export default AccessLogsTableRow;
